export function filterFunction(persons,value){
    const arr=[...persons];
    return arr.filter(obj=> obj.name.toLowerCase().includes(value.toLowerCase()));
}